<div class="app-splash-screen"
     *ngIf="isActive"
>
    <div class="splash-loader-container">
        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    </div>
</div>
